import { Quote } from "@/shared/types/Quote.interface";
import PaymentChoiceFlow from "./PaymentChoiceFlow";
import { useAppLayerContext } from "@/shared/contexts/AppLayer";

interface StripeCheckoutProps {
    quote: Quote;
}

export default function StripeCheckout(props: StripeCheckoutProps) {
    const { quote } = props;
    const { appState } = useAppLayerContext();
    const { stripeHasConfirmationToken, stripeMissingBillingInfo } = appState;

    const renderPaymentOptions = () => {
        if (stripeHasConfirmationToken && stripeMissingBillingInfo) return null;

        return <PaymentChoiceFlow quote={quote} />;
    };

    return <>{renderPaymentOptions()}</>;
}
